import HubwiseManagement from "../../features/hubwiseimportmanagement";
import { FilterProvider, HubwiseJobDefaultFilters } from "../../hooks/FilterContext";
import withProviders from "../../hooks/withProviders";

const HubwiseManagementPage = () => <HubwiseManagement />;

export default withProviders([FilterProvider, { defaultFilters: HubwiseJobDefaultFilters }])(HubwiseManagementPage);